var _defs, _g, _a;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlideDecsPhase4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 768.11 427.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-slide-decs-p4 {\n        stroke-width: .05px;\n      }\n\n      .cls-1-slide-decs-p4, .cls-2-slide-decs-p4, .cls-3-slide-decs-p4 {\n        fill: #fcce14;\n      }\n\n      .cls-1-slide-decs-p4, .cls-3-slide-decs-p4, .cls-4-slide-decs-p4, .cls-5-slide-decs-p4 {\n        stroke: #fcce14;\n      }\n\n      .cls-2-slide-decs-p4, .cls-6-slide-decs-p4, .cls-7-slide-decs-p4, .cls-8-slide-decs-p4, .cls-9-slide-decs-p4, .cls-10-slide-decs-p4 {\n        stroke-width: 0px;\n      }\n\n      .cls-11-slide-decs-p4 {\n        fill: rgba(255, 255, 255, 0);\n        stroke: rgba(0, 0, 0, 0);\n      }\n\n      .cls-6-slide-decs-p4 {\n        fill: #ebf4fb;\n      }\n\n      .cls-7-slide-decs-p4 {\n        fill: #333;\n      }\n\n      .cls-8-slide-decs-p4, .cls-4-slide-decs-p4 {\n        fill: #fff;\n      }\n\n      .cls-9-slide-decs-p4 {\n        fill: #3a414a;\n      }\n\n      .cls-10-slide-decs-p4 {\n        fill: #e51e25;\n      }\n\n      .cls-4-slide-decs-p4 {\n        stroke-width: 2px;\n      }\n\n      .cls-5-slide-decs-p4 {\n        fill: none;\n      }\n\n      .cls-12-slide-decs-p4 {\n        fill: #283676;\n        stroke: #283676;\n      }\n\n      .cls-13-slide-decs-p4 {\n        fill: url(#linear-gradient-1-slide-decs-P4);\n        stroke: #1071e5;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1-slide-decs-P4",
    x1: 4239.46,
    y1: -5955.16,
    x2: 4239.46,
    y2: -6053.83,
    gradientTransform: "translate(-3984.79 -5626.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#cfe4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-slide-decs-p4",
    d: "M83.96,7c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H89.96c-3.31,0-6-2.69-6-6V7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s",
    className: "cls-9-slide-decs-p4",
    d: "M161.92,22.42c5.5,0,8.35,3.12,8.35,8.56,0,4.89-2.38,7.94-6.79,8.56.48,2.04,2.04,3.26,4.69,2.72v1.56c-3.73,1.09-6.45-1.02-6.99-4.14-4.96-.41-7.6-3.46-7.6-8.69s2.85-8.56,8.35-8.56ZM161.92,37.83c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    className: "cls-9-slide-decs-p4",
    d: "M177.13,39.74c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "cls-9-slide-decs-p4",
    d: "M194.58,37.02c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM188.27,35.87c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    className: "cls-9-slide-decs-p4",
    d: "M206.33,28.4c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    className: "cls-9-slide-decs-p4",
    d: "M210.67,36.27c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    className: "cls-9-slide-decs-p4",
    d: "M220.25,26.29c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM223.78,31.79c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-2",
    "data-name": "v",
    className: "cls-9-slide-decs-p4",
    d: "M234.78,28.4c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "cls-9-slide-decs-p4",
    d: "M236.75,39.46v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z",
    className: "cls-9-slide-decs-p4",
    d: "M252.64,26.56l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "A",
    className: "cls-9-slide-decs-p4",
    d: "M261.12,23.78v-2.04h2.17v2.04h-2.17ZM261.12,39.46v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    className: "cls-9-slide-decs-p4",
    d: "M272.8,26.29c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    className: "cls-9-slide-decs-p4",
    d: "M285.77,39.46h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-2",
    "data-name": "x",
    className: "cls-9-slide-decs-p4",
    d: "M297.45,26.29c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM300.98,31.79c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-2",
    "data-name": "B",
    className: "cls-9-slide-decs-p4",
    d: "M312.19,26.29c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-2",
    "data-name": "w",
    className: "cls-9-slide-decs-p4",
    d: "M321.83,36.27c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    className: "cls-9-slide-decs-p4",
    d: "M331.4,26.29c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM331.33,38.11c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-3",
    "data-name": "v",
    className: "cls-9-slide-decs-p4",
    d: "M345.93,28.4c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-2",
    "data-name": "z",
    className: "cls-9-slide-decs-p4",
    d: "M358.43,26.56l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "v-4",
    "data-name": "v",
    className: "cls-9-slide-decs-p4",
    d: "M140.46,57.73c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-3",
    "data-name": "x",
    className: "cls-9-slide-decs-p4",
    d: "M147.59,55.62c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM151.13,61.12c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-2",
    "data-name": "C",
    className: "cls-9-slide-decs-p4",
    d: "M161.72,68.8h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-2",
    "data-name": "A",
    className: "cls-9-slide-decs-p4",
    d: "M168.24,53.11v-2.04h2.17v2.04h-2.17ZM168.24,68.8v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-4",
    "data-name": "x",
    className: "cls-9-slide-decs-p4",
    d: "M178.76,55.62c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM182.29,61.12c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    className: "cls-9-slide-decs-p4",
    d: "M199.54,68.8h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    className: "cls-9-slide-decs-p4",
    d: "M212.3,59.09c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "G",
    className: "cls-9-slide-decs-p4",
    d: "M229.96,55.62c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM229.42,67.44c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-3",
    "data-name": "z",
    className: "cls-9-slide-decs-p4",
    d: "M247.88,55.9l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "G-2",
    "data-name": "G",
    className: "cls-9-slide-decs-p4",
    d: "M262.55,55.62c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM262.01,67.44c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-5",
    "data-name": "v",
    className: "cls-9-slide-decs-p4",
    d: "M276.06,57.73c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-2",
    "data-name": "u",
    className: "cls-9-slide-decs-p4",
    d: "M285.98,66.35c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM279.66,65.2c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-3",
    "data-name": "B",
    className: "cls-9-slide-decs-p4",
    d: "M297.93,55.62c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H",
    className: "cls-9-slide-decs-p4",
    d: "M309.33,55.62c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM309.95,57.25c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "w-3",
    "data-name": "w",
    className: "cls-9-slide-decs-p4",
    d: "M327.94,65.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-5",
    "data-name": "x",
    className: "cls-9-slide-decs-p4",
    d: "M337.51,55.62c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM341.04,61.12c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-3",
    "data-name": "u",
    className: "cls-9-slide-decs-p4",
    d: "M353.88,66.35c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM347.56,65.2c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    className: "cls-9-slide-decs-p4",
    d: "M372.14,57.32c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p4",
    d: "M591.5,48.68l1,.24.94.4.87.53.78.66.66.78.54.88.4.94.23,1,.08,1v14.76h-1v-14.73l-.07-.88-.2-.84-.33-.8-.45-.73-.56-.66-.66-.56-.74-.45-.8-.33-.83-.2-.87-.07h-25.5v-1h25.54l.97.06ZM427.7,49.61v-1h68.16v1h-68.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-slide-decs-p4",
    d: "M427.72,49.61h-.5v-1h.5v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p4",
    d: "M427.74,49.63h-.55v-1.05h.56v1.05ZM427.24,48.63v.95h.46v-.95h-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-slide-decs-p4",
    d: "M596.49,84.63l-4.64-14.27h9.28l-4.64,14.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p4",
    d: "M596.49,86.24l-5.33-16.38h10.65l-5.32,16.38ZM592.54,70.86l3.95,12.15,3.94-12.15h-7.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "J",
    className: "cls-7-slide-decs-p4",
    d: "M512.15,42.18c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM501.02,44.9c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K",
    className: "cls-7-slide-decs-p4",
    d: "M526,50.74c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM522.95,46.05c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    className: "cls-7-slide-decs-p4",
    d: "M534.83,53.79c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    className: "cls-7-slide-decs-p4",
    d: "M536.8,38.79v-2.51h3.4v2.51h-3.4ZM536.8,54v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    className: "cls-7-slide-decs-p4",
    d: "M551.06,43.81c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K-2",
    "data-name": "K",
    className: "cls-7-slide-decs-p4",
    d: "M563.96,50.74c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM560.91,46.05c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13-slide-decs-p4",
    d: "M156.66,334.53c0-3.31,2.69-6,6-6h184.02c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-184.02c-3.31,0-6-2.69-6-6v-86.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "cls-8-slide-decs-p4",
    d: "M195.37,371.33c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    className: "cls-8-slide-decs-p4",
    d: "M212.75,380.42c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM209.7,375.74c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-2",
    "data-name": "P",
    className: "cls-8-slide-decs-p4",
    d: "M226.33,380.42c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM223.28,375.74c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Q",
    className: "cls-8-slide-decs-p4",
    d: "M235.77,366.84c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84ZM239.3,375.06c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "cls-8-slide-decs-p4",
    d: "M258.18,373.02c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    className: "cls-8-slide-decs-p4",
    d: "M274.34,381.37c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM271.08,381.58c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "cls-8-slide-decs-p4",
    d: "M288.19,374.31c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-3",
    "data-name": "P",
    className: "cls-8-slide-decs-p4",
    d: "M305.03,380.42c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM301.97,375.74c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "U",
    className: "cls-8-slide-decs-p4",
    d: "M325.2,371.33c0,5.3-5.7,5.84-7.54,9.57h7.81v2.78h-11.81c-.41-6.86,6.72-6.79,8.15-12.22.07-1.49-.81-2.1-2.24-2.17-1.56,0-2.17.95-2.38,2.31l-3.33-.2c.34-3.06,2.17-4.75,5.7-4.75s5.64,1.49,5.64,4.69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-slide-decs-p4",
    d: "M83.96,173.16c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H89.96c-3.31,0-6-2.69-6-6v-86.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "V",
    className: "cls-9-slide-decs-p4",
    d: "M171.56,216c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    className: "cls-9-slide-decs-p4",
    d: "M181.21,209.14c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM180.66,220.95c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H-2",
    "data-name": "H",
    className: "cls-9-slide-decs-p4",
    d: "M192.75,209.14c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM193.36,210.77c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-4",
    "data-name": "u",
    className: "cls-9-slide-decs-p4",
    d: "M210.13,219.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM203.82,218.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-4",
    "data-name": "w",
    className: "cls-9-slide-decs-p4",
    d: "M218.14,219.12c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-6",
    "data-name": "x",
    className: "cls-9-slide-decs-p4",
    d: "M227.72,209.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM231.25,214.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "D-2",
    "data-name": "D",
    className: "cls-9-slide-decs-p4",
    d: "M248.09,209.14c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM248.02,220.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X",
    className: "cls-9-slide-decs-p4",
    d: "M261.74,206.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "I-2",
    "data-name": "I",
    className: "cls-9-slide-decs-p4",
    d: "M282.72,210.84c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-5",
    "data-name": "u",
    className: "cls-9-slide-decs-p4",
    d: "M298.33,219.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM292.02,218.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-5",
    "data-name": "w",
    className: "cls-9-slide-decs-p4",
    d: "M306.35,219.12c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-7",
    "data-name": "x",
    className: "cls-9-slide-decs-p4",
    d: "M315.92,209.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM319.45,214.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-6",
    "data-name": "v",
    className: "cls-9-slide-decs-p4",
    d: "M330.45,211.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-3",
    "data-name": "A",
    className: "cls-9-slide-decs-p4",
    d: "M332.42,206.63v-2.04h2.17v2.04h-2.17ZM332.42,222.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-6",
    "data-name": "u",
    className: "cls-9-slide-decs-p4",
    d: "M345.73,219.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM339.41,218.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-2",
    "data-name": "y",
    className: "cls-9-slide-decs-p4",
    d: "M351.37,222.31v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p4",
    d: "M493.08,217h-65.37v-1h65.37v1ZM596.98,210.52l-.07,1-.24.98-.4.95-.52.87-.65.77-.78.68-.87.53-.94.4-1,.24-1,.08h-28.3v-1h28.27l.88-.07.85-.2.8-.34.73-.44.66-.56.56-.65.45-.74.33-.78.2-.84.07-.88v-9.2h1l-.03,9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-slide-decs-p4",
    d: "M427.72,217h-.5v-1h.5v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p4",
    d: "M427.74,217.02h-.55v-1.05h.56v1.05ZM427.24,216.02v.95h.46v-.96h-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-slide-decs-p4",
    d: "M601.12,200.78h-9.27l4.65-14.25,4.62,14.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p4",
    d: "M601.81,201.28h-10.65l5.33-16.37,5.32,16.37ZM592.54,200.28h7.9l-3.95-12.13-3.95,12.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g-2",
    "data-name": "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "J-2",
    "data-name": "J",
    className: "cls-7-slide-decs-p4",
    d: "M509.38,209.57c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM498.24,212.29c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K-3",
    "data-name": "K",
    className: "cls-7-slide-decs-p4",
    d: "M523.23,218.13c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM520.17,213.44c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-2",
    "data-name": "L",
    className: "cls-7-slide-decs-p4",
    d: "M532.06,221.18c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M-2",
    "data-name": "M",
    className: "cls-7-slide-decs-p4",
    d: "M534.03,206.17v-2.51h3.4v2.51h-3.4ZM534.03,221.38v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-2",
    "data-name": "N",
    className: "cls-7-slide-decs-p4",
    d: "M548.29,211.2c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K-4",
    "data-name": "K",
    className: "cls-7-slide-decs-p4",
    d: "M561.19,218.13c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM558.13,213.44c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p4",
    d: "M255.08,267.33l-.3,44.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p4",
    d: "M255.58,267.34h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-slide-decs-p4",
    d: "M254.68,326.42l-4.54-14.3,9.27.06-4.73,14.24Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rect4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11-slide-decs-p4",
    d: "M425.36,92.24c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-86.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "cls-9-slide-decs-p4",
    d: "M537.07,129.04c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z",
    className: "cls-9-slide-decs-p4",
    d: "M554.45,138.13c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM551.4,133.45c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-2",
    "data-name": "Z",
    className: "cls-9-slide-decs-p4",
    d: "M568.03,138.13c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM564.98,133.45c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "cls-9-slide-decs-p4",
    d: "M577.47,124.55c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84ZM581,132.77c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "cls-9-slide-decs-p4",
    d: "M599.88,130.73c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "cls-9-slide-decs-p4",
    d: "M616.04,139.08c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM612.78,139.29c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "cls-9-slide-decs-p4",
    d: "M629.89,132.02c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-3",
    "data-name": "Z",
    className: "cls-9-slide-decs-p4",
    d: "M646.73,138.13c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM643.67,133.45c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "cls-9-slide-decs-p4",
    d: "M663.98,135.89c0-3.12-3.73-3.73-4.96-1.83h-3.26l.61-9.51h10.12v2.51h-7.06l-.27,4.28c2.99-2.58,9.03-.27,8.28,4.48.75,6.99-11.48,7.94-12.15,1.36l3.33-.27c.34,1.22,1.02,2.04,2.65,2.04,1.77,0,2.72-1.22,2.72-3.06"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p4",
    d: "M255.09,101.18v48.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p4",
    d: "M255.59,101.18h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-slide-decs-p4",
    d: "M255.09,164.54l-4.64-14.26h9.28l-4.64,14.26Z"
  }))), _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "#popup_flight_travlDil40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p4",
    d: "M5.01,197.05h64.1v33.6H5.01v-33.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-slide-decs-p4",
    d: "M73.37,198.82L4.65,233.45l-2.3-4.56,68.72-34.63,2.3,4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10-slide-decs-p4",
    d: "M72.25,196.75L3.53,231.39l-.68-1.35,68.72-34.63.68,1.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-slide-decs-p4",
    d: "M70.11,233.45L1.68,198.25l2.34-4.55,68.43,35.2-2.34,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10-slide-decs-p4",
    d: "M43.91,218.43L1.68,196.7l.63-1.22,42.23,21.73-.63,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10-slide-decs-p4",
    d: "M71.17,230.95l-24.66-12.7.67-1.28,24.65,12.68-.66,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-slide-decs-p4",
    d: "M2.81,209.28h69.02v9.15H2.83l-.02-9.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-slide-decs-p4",
    d: "M41.64,195.35v36.2h-9.16v-36.2h9.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10-slide-decs-p4",
    d: "M2.81,210.75h69.02v6.22H2.83l-.02-6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10-slide-decs-p4",
    d: "M40.25,196.54v34.85h-6.37v-34.85h6.37Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6-slide-decs-p4",
    y: 191.75,
    width: 74.55,
    height: 4.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6-slide-decs-p4",
    x: 0.15,
    y: 191.79,
    width: 4.36,
    height: 42.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6-slide-decs-p4",
    x: 0.15,
    y: 231.1,
    width: 75.3,
    height: 5.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6-slide-decs-p4",
    x: 69.68,
    y: 191.75,
    width: 5.51,
    height: 45.28
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideDecsPhase4);
export default __webpack_public_path__ + "static/media/Slide_Decs_Phase_4.e3cb37aba8a6429942fa28a384d5adc6.svg";
export { ForwardRef as ReactComponent };